import netsLocalization from './nets-localization';

export default angular
  .module('app.localization', [])
  .component('netsLocalization', netsLocalization);
